import React, { useEffect } from 'react'
import { getUserInfoSync } from '../../config/api'

const SideBar = ({ activeScreen, setActiveScreen, isFirstLogin }) => {
  const userInfo = getUserInfoSync()
  const firstLogin = isFirstLogin || userInfo?.first_login === true

  const handleMenuClick = (screen) => {
    // If first login, only allow profile screen
    if (firstLogin && screen !== 'profile') {
      return
    }
    setActiveScreen(screen)
  }

  const isActive = (screen) => {
    return activeScreen === screen ? '' : 'collapsed'
  }

  const isSubActive = (screen) => {
    return activeScreen === screen ? 'active' : ''
  }

  // Ensure Bootstrap collapse is initialized
  useEffect(() => {
    const initBootstrap = () => {
      if (window.bootstrap && window.bootstrap.Collapse) {
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(element => {
          // eslint-disable-next-line no-new
          new window.bootstrap.Collapse(element, { toggle: false })
        })
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBootstrap)
    } else {
      initBootstrap()
    }
  }, [])

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {/* Create Company */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('create-company')} ${firstLogin ? 'disabled' : ''}`} 
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('create-company'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-building-add" />
            <span>Create Company</span>
          </a>
        </li>

        {/* Manage Company */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('manage-company')} ${firstLogin ? 'disabled' : ''}`} 
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('manage-company'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-building-gear" />
            <span>Manage Company</span>
          </a>
        </li>

        {/* Manage Payments */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('manage-payments')} ${firstLogin ? 'disabled' : ''}`} 
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('manage-payments'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-credit-card" />
            <span>Manage Payments</span>
          </a>
        </li>

        {/* Profile */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isSubActive('profile')}`} 
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('profile'); }}
          >
            <i className="bi bi-person" />
            <span>Profile</span>
          </a>
        </li>
      </ul>
    </aside>
  )
}

export default SideBar